import { Card, CardContent } from "components/Card"
import { Text } from "components/Text"
import { Image } from "components/Image"

export const GiftCard = ({ gift }) => {
  return (
    <Card spacing="small">
      <CardContent>
        <Image
          imageFile={gift.imageFile}
          size="w640"
          className="w-full h-48 object-contain"
        />
      </CardContent>
      <CardContent>
        <Text variant="headline5" className="text-dark">
          {gift.title}
        </Text>
        <Text variant="caption">{gift.subtitle}</Text>
      </CardContent>
    </Card>
  )
}
